module.exports = __webpack_public_path__ + "static/media/gift.63e6d679.svg";